<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toca"><a href="#/xhtml/04_Preface"><em class="italic">Preface</em></a></h2>
<h2 class="toc"><a href="#/xhtml/05_Chapter1"><span class="bold">Chapter 1</span><span class="space">Over the Unicorn’s Horn (1606–1629)</span></a></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter2" title="Link target outside of Sample"><span class="bold">Chapter 2</span><span class="space">Venus and Mercury (1630–1633)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter3" title="Link target outside of Sample"><span class="bold">Chapter 3</span><span class="space">Wit, Honour and Love (1634–1635)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter4" title="Link target outside of Sample"><span class="bold">Chapter 4</span><span class="space">For Queen and Country (1635–1637)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter5" title="Link target outside of Sample"><span class="bold">Chapter 5</span><span class="space">The Arts of Government (1638)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter6" title="Link target outside of Sample"><span class="bold">Chapter 6</span><span class="space">As If (1638–1639)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter7" title="Link target outside of Sample"><span class="bold">Chapter 7</span><span class="space">Times of Humiliation (1640–1645)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter8" title="Link target outside of Sample"><span class="bold">Chapter 8</span><span class="space">The Art of the Heroic (1645–1650)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter9" title="Link target outside of Sample"><span class="bold">Chapter 9</span><span class="space">Entr’Acte</span></span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter10" title="Link target outside of Sample"><span class="bold">Chapter 10</span><span class="space1">How Daphne Pays His Debts (1654–1659)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter11" title="Link target outside of Sample"><span class="bold">Chapter 11</span><span class="space1">Restoration Theatre Restoration (1660–1662)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter12" title="Link target outside of Sample"><span class="bold">Chapter 12</span><span class="space1">Cavalier with Shakespeare (1663–1664)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter13" title="Link target outside of Sample"><span class="bold">Chapter 13</span><span class="space1">Rough Magic (1664–1667)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter14" title="Link target outside of Sample"><span class="bold">Chapter 14</span><span class="space1">Finale (1668–1710)</span></span></h2>
<h2 class="toc"><span href="#/xhtml/19_Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></h2>
<h2 class="toca"><span href="#/xhtml/20_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?70ec1f89